import React from "react";
import { Link } from "react-router-dom";
import PageTitle from "./include/PageTitle";
import { useI18n } from "../i18n/I18nContext";
import { getServiceDetailsCopy, getSidebarLinks } from "../content/localeCopy";
import LocalizedLeadParagraph from "../Components/LocalizedLeadParagraph";
import { useTranslatedCopy } from "../i18n/useTranslatedCopy";
import ServiceInquiryForm from "../Components/ServiceInquiryForm";
import Seo, { ARABIC_SEO_KEYWORDS, ENGLISH_SEO_KEYWORDS, buildServiceStructuredData, mergeSeoKeywords } from "../Components/Seo";

const marketingPageImages = [
  "/img/service/real-estate-marketing-service-1.png",
  "/img/service/real-estate-marketing-service-2.png",
  "/img/service/real-estate-marketing-service-3.png",
];

const marketingSidebarImage = "/img/service/gallery_1.jpg";

const imageCardStyle = {
  background: "#ffffff",
  border: "1px solid rgba(187, 165, 92, 0.14)",
  borderRadius: "22px",
  overflow: "hidden",
  boxShadow: "0 16px 38px rgba(15, 23, 42, 0.08)",
  height: "100%",
};

const RealStateMarketingServiceDetail = () => {
  const { locale } = useI18n();
  const copy = useTranslatedCopy(getServiceDetailsCopy("marketing"), locale);
  const sidebar = useTranslatedCopy(getSidebarLinks(), locale);
  const moreDetailsHeading = useTranslatedCopy("More about this service", locale);
  const matrixHeaderPhase = useTranslatedCopy("Phase", locale);
  const matrixHeaderDetails = useTranslatedCopy("Details", locale);
  const galleryCaptionOne = useTranslatedCopy("Professional presentation and listing quality", locale);
  const galleryCaptionTwo = useTranslatedCopy("Campaign support and buyer-facing visibility", locale);
  const marketingGalleryTitle = useTranslatedCopy("Your property presented with stronger market appeal", locale);
  const marketingGalleryText = useTranslatedCopy(
    "Our marketing work combines visual presentation, market exposure and active follow-up to attract the right audience and improve conversion opportunities.",
    locale
  );
  const marketingJourneyHeading = useTranslatedCopy("Your Property’s Marketing Journey with Us", locale);

  const closingStatement = useTranslatedCopy(
    "Your property deserves to be seen by everyone... Start your journey to success with us today.",
    locale
  );

  return (
    <div>
      <Seo
        title="Real Estate Marketing in Saudi Arabia and Al Khobar | QTECH"
        titleAr="ØªØ³ÙˆÙŠÙ‚ Ø¹Ù‚Ø§Ø±ÙŠ ÙÙŠ Ø§Ù„Ø®Ø¨Ø± ÙˆØ§Ù„Ù…Ù†Ø·Ù‚Ø© Ø§Ù„Ø´Ø±Ù‚ÙŠØ© | Ø´Ø±ÙƒØ© ØªÙ‚Ù†ÙŠØ§Øª Ø§Ù„Ø¬ÙˆØ¯Ø©"
        description="QTECH delivers real estate marketing services in Saudi Arabia and Al Khobar, including digital campaigns, property presentation, audience targeting, and market visibility for faster sales and leasing."
        descriptionAr="ØªÙ‚Ø¯Ù… Ø´Ø±ÙƒØ© ØªÙ‚Ù†ÙŠØ§Øª Ø§Ù„Ø¬ÙˆØ¯Ø© Ø®Ø¯Ù…Ø§Øª ØªØ³ÙˆÙŠÙ‚ Ø¹Ù‚Ø§Ø±ÙŠ ÙÙŠ Ø§Ù„Ø®Ø¨Ø± ÙˆØ§Ù„Ù…Ù†Ø·Ù‚Ø© Ø§Ù„Ø´Ø±Ù‚ÙŠØ© Ù„Ù„Ø¹Ù‚Ø§Ø±Ø§Øª ÙˆØ§Ù„Ø´Ù‚Ù‚ ÙˆØ§Ù„ÙÙ„Ù„ØŒ Ù…Ø¹ Ø­Ù…Ù„Ø§Øª Ø¹Ù‚Ø§Ø±ÙŠØ© ØªØ³Ø§Ø¹Ø¯ Ø¹Ù„Ù‰ Ø§Ù„Ø¨ÙŠØ¹ ÙˆØ§Ù„ØªØ£Ø¬ÙŠØ± ÙˆØ§Ù„Ø§Ø³ØªØ«Ù…Ø§Ø± Ø§Ù„Ø¹Ù‚Ø§Ø±ÙŠ."
        keywords={mergeSeoKeywords(
          ENGLISH_SEO_KEYWORDS.marketing,
          "investment property marketing Saudi Arabia, real estate investment marketing, marketing investment apartments Al Khobar, real estate marketing for investors"
        )}
        keywordsAr={mergeSeoKeywords(
          ARABIC_SEO_KEYWORDS.marketing,
          "تسويق عقارات استثمارية, استثمار عقاري, تسويق استثماري عقاري, تسويق شقق استثمارية, تسويق عقاري للمستثمرين"
        )}
        path="/real-estate-marketing-saudi-arabia"
        image={marketingPageImages[0]}
        structuredData={buildServiceStructuredData({
          name: "Real Estate Marketing in Saudi Arabia | QTECH",
          nameAr: "Ã˜ÂªÃ˜Â³Ã™Ë†Ã™Å Ã™â€š Ã˜Â¹Ã™â€šÃ˜Â§Ã˜Â±Ã™Å  Ã™ÂÃ™Å  Ã˜Â§Ã™â€žÃ˜Â®Ã˜Â¨Ã˜Â± Ã™Ë†Ã˜Â§Ã™â€žÃ™â€¦Ã™â€ Ã˜Â·Ã™â€šÃ˜Â© Ã˜Â§Ã™â€žÃ˜Â´Ã˜Â±Ã™â€šÃ™Å Ã˜Â© | Ã˜Â´Ã˜Â±Ã™Æ’Ã˜Â© Ã˜ÂªÃ™â€šÃ™â€ Ã™Å Ã˜Â§Ã˜Âª Ã˜Â§Ã™â€žÃ˜Â¬Ã™Ë†Ã˜Â¯Ã˜Â©",
          description:
            "QTECH delivers real estate marketing services in Saudi Arabia, including digital campaigns, property presentation, audience targeting, and market visibility for faster sales and leasing.",
          descriptionAr:
            "Ã˜ÂªÃ™â€šÃ˜Â¯Ã™â€¦ Ã˜Â´Ã˜Â±Ã™Æ’Ã˜Â© Ã˜ÂªÃ™â€šÃ™â€ Ã™Å Ã˜Â§Ã˜Âª Ã˜Â§Ã™â€žÃ˜Â¬Ã™Ë†Ã˜Â¯Ã˜Â© Ã˜Â®Ã˜Â¯Ã™â€¦Ã˜Â§Ã˜Âª Ã˜ÂªÃ˜Â³Ã™Ë†Ã™Å Ã™â€š Ã˜Â¹Ã™â€šÃ˜Â§Ã˜Â±Ã™Å  Ã™ÂÃ™Å  Ã˜Â§Ã™â€žÃ˜Â®Ã˜Â¨Ã˜Â± Ã™Ë†Ã˜Â§Ã™â€žÃ™â€¦Ã™â€ Ã˜Â·Ã™â€šÃ˜Â© Ã˜Â§Ã™â€žÃ˜Â´Ã˜Â±Ã™â€šÃ™Å Ã˜Â© Ã™â€žÃ™â€žÃ˜Â¹Ã™â€šÃ˜Â§Ã˜Â±Ã˜Â§Ã˜Âª Ã™Ë†Ã˜Â§Ã™â€žÃ˜Â´Ã™â€šÃ™â€š Ã™Ë†Ã˜Â§Ã™â€žÃ™ÂÃ™â€žÃ™â€žÃ˜Å’ Ã™â€¦Ã˜Â¹ Ã˜Â­Ã™â€¦Ã™â€žÃ˜Â§Ã˜Âª Ã˜Â¹Ã™â€šÃ˜Â§Ã˜Â±Ã™Å Ã˜Â© Ã˜ÂªÃ˜Â³Ã˜Â§Ã˜Â¹Ã˜Â¯ Ã˜Â¹Ã™â€žÃ™â€° Ã˜Â§Ã™â€žÃ˜Â¨Ã™Å Ã˜Â¹ Ã™Ë†Ã˜Â§Ã™â€žÃ˜ÂªÃ˜Â£Ã˜Â¬Ã™Å Ã˜Â± Ã™Ë†Ã˜Â§Ã™â€žÃ˜Â§Ã˜Â³Ã˜ÂªÃ˜Â«Ã™â€¦Ã˜Â§Ã˜Â± Ã˜Â§Ã™â€žÃ˜Â¹Ã™â€šÃ˜Â§Ã˜Â±Ã™Å .",
          path: "/real-estate-marketing-saudi-arabia",
          image: marketingPageImages[0],
          serviceType: "Real Estate Marketing",
        })}
      />

      <PageTitle
        title={copy.title}
        currentPage={copy.title}
        bgImage="/img/bg/14.jpg"
      />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <div className="ltn__blog-img">
                  <img
                    src={marketingPageImages[0]}
                    alt={copy.imageLabel}
                    style={{ width: "100%", minHeight: "460px", objectFit: "cover" }}
                  />
                </div>

                <h2 className="title-2">{copy.imageLabel}</h2>

                {copy.paragraphs.map((text, index) => (
                  <LocalizedLeadParagraph
                    key={index}
                    text={text}
                    index={index}
                    locale={locale}
                  />
                ))}

                {Array.isArray(copy.highlights) && copy.highlights.length > 0 ? (
                  <div className="qtech-service-highlight-list">
                    {copy.highlights.map((item, index) => (
                      <div className="qtech-service-highlight-card" key={item.title || index}>
                        <h5>{item.title}</h5>
                        <p>{item.body}</p>
                      </div>
                    ))}
                  </div>
                ) : null}

                <div
                  style={{
                    marginTop: "34px",
                    marginBottom: "18px",
                    padding: "0 2px",
                  }}
                >
                  <h4
                    className="title-2"
                    style={{
                      marginBottom: "10px",
                    }}
                  >
                    {marketingGalleryTitle}
                  </h4>
                  <p
                    style={{
                      marginBottom: "0",
                      color: "#5c727d",
                      lineHeight: "1.8",
                    }}
                  >
                    {marketingGalleryText}
                  </p>
                </div>

                <div className="row g-4 mb-4">
                  {marketingPageImages.slice(1).map((image, index) => {
                    const imageCaptions = [galleryCaptionOne, galleryCaptionTwo];

                    return (
                      <div className="col-md-6" key={image}>
                        <div style={imageCardStyle}>
                          <img
                            src={image}
                            alt={`${copy.imageLabel} ${index + 2}`}
                            style={{
                              width: "100%",
                              height: "290px",
                              objectFit: "cover",
                              display: "block",
                            }}
                          />
                          <div
                            style={{
                              padding: "16px 18px 18px",
                              background: "#fffdfa",
                              borderTop: "1px solid rgba(187, 165, 92, 0.12)",
                            }}
                          >
                            <div
                              style={{
                                display: "inline-block",
                                fontSize: "11px",
                                fontWeight: "700",
                                letterSpacing: "0.05em",
                                textTransform: "uppercase",
                                color: "#bba55c",
                                marginBottom: "6px",
                              }}
                            >
                              {copy.imageLabel}
                            </div>
                            <p
                              style={{
                                margin: 0,
                                color: "#1f2937",
                                fontWeight: 600,
                                lineHeight: 1.6,
                              }}
                            >
                              {imageCaptions[index] || copy.imageLabel}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {Array.isArray(copy.moreDetails) && copy.moreDetails.length > 0 ? (
                  <>
                    <h4 className="title-2 mt-4">{moreDetailsHeading}</h4>

                    {copy.moreDetails.map((text, index) => (
                      <LocalizedLeadParagraph
                        key={`below-images-${index}`}
                        text={text}
                        index={index + 10}
                        locale={locale}
                      />
                    ))}
                  </>
                ) : null}

                <h4 className="title-2 mt-4">{marketingJourneyHeading}</h4>

                {Array.isArray(copy.serviceMatrix) && copy.serviceMatrix.length > 0 ? (
                  <div className="qtech-service-matrix">
                    <div className="qtech-service-matrix__header">
                      <span>{matrixHeaderPhase}</span>
                      <span>{matrixHeaderDetails}</span>
                    </div>
                    {copy.serviceMatrix.map((row, index) => (
                      <div className="qtech-service-matrix__row" key={row.service || index}>
                        <div className="qtech-service-matrix__service">{row.service}</div>
                        <div className="qtech-service-matrix__details">{row.details}</div>
                      </div>
                    ))}
                  </div>
                ) : null}

                <p
                  style={{
                    marginTop: "20px",
                    marginBottom: 0,
                    color: "#1f2937",
                    fontWeight: 600,
                    lineHeight: "1.8",
                  }}
                >
                  {closingStatement}
                </p>

              </div>
            </div>

            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    {sidebar.map((item) => (
                      <li
                        key={item.to}
                        className={
                          item.to === "/real-estate-marketing-saudi-arabia" ? "active" : ""
                        }
                      >
                        <Link to={item.to}>
                          {item.label}
                          <span>
                            <i className="fas fa-arrow-right" />
                          </span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>

                <ServiceInquiryForm
                  serviceTitle={copy.title}
                  serviceSlug="real-estate-marketing-saudi-arabia"
                />

                <div className="widget ltn__banner-widget">
                  <a href="/shop.html">
                    <img
                      src={marketingSidebarImage}
                      alt={copy.imageLabel}
                      style={{ width: "100%", minHeight: "320px", objectFit: "cover" }}
                    />
                  </a>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RealStateMarketingServiceDetail;
